import {useSelector} from "react-redux";
import Attachment from "./attachment";
import WorkspaceMediaThumbnail from "../../system/components/workspace-media-thumbnail";

export function useAttachment() {
    const activeWorkspaceId = useSelector(state => state.app.workspaceId);

    const getAttachments = async (workspaceId, projectId)=>{
        try {
            const attachment = new Attachment();
            const query = {
                filters: {
                    $and:[
                        {workspace:{$eq: workspaceId}},
                        {project:{$eq: projectId}},
                        {attachments:{$notNull: true}},
                    ],
                },
                populate: {
                    "attachments": {populate: "*"},
                    "createdBy": true,
                },
            }
            const _data = await attachment.getAll(query);

            return _data.data
        }catch (e){

        }
    }
    const prepareTable = ({actions})=>{
        const fields=["icon", "name", "related", "uploader", "createdAt"]//Object.keys(DeviceEntity.fields);
        const value=(item)=>{
            return(
                <div className="flex gap-1 align-items-center text-xs">
                    <span className="pi pi-eye cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{}}/>
                    {/*<span className="pi pi-file-edit cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{actions.onEditClicked({value:item})}}/>*/}
                    {/*<span className={`pi pi-power-off cursor-pointer hover:surface-100 border-circle p-3 ${item.kphwms_isonline?"text-red-500":"text-green-500"}`} onClick={()=>{actions.onPowerOffClicked({value:item})}}/>*/}
                    {/*<span className="pi pi-sync cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{console.log(item)}}/>*/}
                    {/*<span className="pi pi-trash cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{actions.onDeleteClicked({value:item})}}/>*/}
                </div>
            )
        }
        const icon=(item)=>{
            return(
                <div className="flex gap-1 align-items-center text-xs">
                    <div className="h-2rem">
                        {item && <WorkspaceMediaThumbnail file={item} workspaceId={activeWorkspaceId} width="2rem"/>}
                    </div>
                    {/*<span className="pi pi-eye cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{}}/>*/}
                    {/*<span className="pi pi-file-edit cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{actions.onEditClicked({value:item})}}/>*/}
                    {/*<span className={`pi pi-power-off cursor-pointer hover:surface-100 border-circle p-3 ${item.kphwms_isonline?"text-red-500":"text-green-500"}`} onClick={()=>{actions.onPowerOffClicked({value:item})}}/>*/}
                    {/*<span className="pi pi-sync cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{console.log(item)}}/>*/}
                    {/*<span className="pi pi-trash cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{actions.onDeleteClicked({value:item})}}/>*/}
                </div>
            )
        }

        const related=(item)=>{

            const RelatedItemTemplate = (data)=>{
                switch (data.__type) {
                    case "api::task.task":return(<div className="text-right">{data.title}</div>)
                    case "api::project.project":return(<div className="text-right">{data.title}</div>)
                    default:return null;
                }
            }


            return(
                <div className="flex gap-1 align-items-center text-xs">
                    <span>
                        {item.related.map(r=>(<RelatedItemTemplate {...r}/>))}
                    </span>
                    {/*<span className="pi pi-eye cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{}}/>*/}
                    {/*<span className="pi pi-file-edit cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{actions.onEditClicked({value:item})}}/>*/}
                    {/*<span className={`pi pi-power-off cursor-pointer hover:surface-100 border-circle p-3 ${item.kphwms_isonline?"text-red-500":"text-green-500"}`} onClick={()=>{actions.onPowerOffClicked({value:item})}}/>*/}
                    {/*<span className="pi pi-sync cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{console.log(item)}}/>*/}
                    {/*<span className="pi pi-trash cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{actions.onDeleteClicked({value:item})}}/>*/}
                </div>
            )
        }

        const fieldsConfig = {
            icon:{alias:" ", value:icon, type:"ACTIONS", "class-name":"w-1rem pl-1 pr-1", translate:true,},
            name:{type:"TEXT", "class-name":"flex-1 pl-3 pr-3", translate:true,},
            related:{alias:"used-in",type:"ACTIONS", value:related, "class-name":"flex-1 pl-3 pr-3", translate:true,},
            uploader:{alias:"created-by",type:"TEXT", "class-name":"flex-1 pl-3 pr-3", translate:true,},
            createdAt:{alias:"uploaded-at",type:"PERSIAN_DATE",format:"YYYY/MM/DD", "class-name":"flex-1 pl-3 pr-3", translate:true,},
            actions:{type:"ACTIONS", value, translate:true, "class-name":"w-3rem"},
        }
        return {fields, fieldsConfig}
    }

    return {getAttachments, prepareTable};
}
